module.exports = __webpack_public_path__ + "img/1544091559.e01c1b73.jpg";